var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nomore-container"},[_c('div',{staticClass:"nomore"},[_vm._v("没有更多了")])])
}]

export { render, staticRenderFns }